module.exports = __webpack_public_path__ + "img/threshold-on.b80dc212.svg";